<template>
  <main class="app-layout" :class="appLayoutClass">
    <div class="layout__impersonate-banner-wrapper">
      <ImpersonateBanner
        class="layout__impersonate-banner"
        v-if="!fullscreen"
      />
    </div>
    <div class="layout__header-wrapper" v-if="!fullscreen">
      <Header class="layout__header" />
    </div>
    <div class="layout__content-wrapper">
      <router-view class="layout__content" />
    </div>
    <div class="layout__footer-wrapper" v-if="!fullscreen">
      <Footer class="layout__footer" />
    </div>
  </main>
  <div
    v-if="useNotifications().queue.value.length > 0"
    class="layout__notification-area-wrapper"
  >
    <NotificationArea class="layout__notification-area" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Header from "@/components/header/Header.vue";
import Footer from "@/components/footer/Footer.vue";
import { useRoute } from "vue-router";
import { RouteNames } from "@/router";
import ImpersonateBanner from "@/components/impersonate-banner/ImpersonateBanner.vue";
import NotificationArea from "@/components/notification/NotificationArea.vue";
import { useGeneralStore } from "@/stores/general";
import { useNotifications } from "@/common/notification";

const route = useRoute();

const fullContentPages = [
  RouteNames.PAGE_NOT_FOUND,
  RouteNames.DOWNLOAD,
  RouteNames.NO_MOBILE,
  RouteNames.SHIPMENT_TRACKING,
];

const wideContentPages = [
  RouteNames.REGISTRATION,
  RouteNames.REGISTRATION_EMAIL_CONFIRM,
  RouteNames.REGISTRATION_SUCCESS,
  RouteNames.LOGIN,
  RouteNames.PASSWORD_FORGOT,
  RouteNames.PASSWORD_FORGOT_SUCCESS,
  RouteNames.PASSWORD_RESET,
  RouteNames.PASSWORD_CHANGE_REQUIRED,
  RouteNames.PASSWORD_CHANGE_OPTIONAL,
  RouteNames.OFFER_SENT,
  RouteNames.CUSTOMER_ADDRESS_CONFIRMATION,
  RouteNames.CUSTOMER_ADDRESS_REQUEST,
  RouteNames.REQUEST_CONFIRMED,
  RouteNames.REQUEST_SENT,
];

const processContentPages = [RouteNames.ADDRESS];

const generalStore = useGeneralStore();

const fullscreen = computed(() => {
  return generalStore.fullscreen;
});

const appLayoutClass = computed(() => {
  if (generalStore.fullscreen) {
    return "app-layout--fullscreen-content";
  }

  if (fullContentPages.includes(route.name as RouteNames)) {
    return "app-layout--full-content";
  }

  if (wideContentPages.includes(route.name as RouteNames)) {
    return "app-layout--wide-content";
  }

  if (processContentPages.includes(route.name as RouteNames)) {
    return "app-layout--process-content";
  }

  return "app-layout--default";
});
</script>

<style scoped lang="scss"></style>
